// extracted by mini-css-extract-plugin
export default {"reviewCount":"_2BiQaxFe2dszTg10Hm9u5l b-profile-card__review-count","icon":"_3W8pKqfNyxev9W1hulMMtb b-profile-card__review-count-icon"};